import React, { Component } from "react";
import PropTypes from "prop-types";
import { constructUrl } from "../../util";
import IS_CLIENT_RENDERED from "../../util/isClientRendered";
import mixpanel from "../../services/mixpanel";
import windowDataLayer from "../../util/windowDataLayer";

class ShareButton extends Component {
  constructor(props) {
    super(props);
    this.sharePost = this.sharePost.bind(this);
  }

  render() {
    return <span onClick={this.sharePost}>{this.props.children}</span>;
  }

  sharePost() {
    if (IS_CLIENT_RENDERED) {
      const sharingUrl = constructUrl(this.props.platformUrl, this.props.platformOptions);
      const sharingWindowWidth = 600;
      const sharingWindowHeight = 400;
      const sharingWindowLeft = window.innerWidth / 2 - sharingWindowWidth / 2;
      const sharingWindowTop = window.innerHeight / 2 - sharingWindowHeight / 2;
      window.open(
        sharingUrl,
        "sharingWindow",
        `width=${sharingWindowWidth},height=${sharingWindowHeight},top=${sharingWindowTop},left=${sharingWindowLeft}`
      );

      switch (this.props.eventSource) {
        case "post":
          mixpanel.track("post.share", {
            postUrl: this.props.postUrl,
            platformName: this.props.platformName,
          });
          break;

        case "collection":
          mixpanel.track("collection.share", {
            collectionUrl: this.props.postUrl,
            platformName: this.props.platformName,
          });
          break;
      }
      windowDataLayer.push({ event: `share.${this.props.platformName}`, platformName: this.props.platformName });
    }
  }
}

ShareButton.propTypes = {
  platformUrl: PropTypes.string.isRequired,
  platformName: PropTypes.string.isRequired,
  platformOptions: PropTypes.object.isRequired,
};

export default ShareButton;



// WEBPACK FOOTER //
// ./src/components/ShareButton/index.js